import { combineEpics } from "redux-observable";

import {
  loginEpic,
  logoutEpic,
  loginFormRequestEpic,
  loginFormSuccessEpic,
  loginFormFailureEpic,
  forgotPasswordEpic,
  forgotPasswordFormRequestEpic,
  forgotPasswordFormSuccessEpic,
  forgotPasswordFormFailureEpic,
  resetPasswordEpic,
  resetPasswordFormRequestEpic,
  resetPasswordFormSuccessEpic,
  resetPasswordFormFailureEpic
} from "./login";

import { loadHistoryEpic } from "./history";

import { handleErrorEpic } from "./error";
import {
  loadPatientsEpic,
  loadPatientEpic,
  savePatientEpic,
  deletePatientEpic,
  savePatientConditionEpic,
  savePatientSuccessEpic,
  linkProgramEpic,
  savePatientProgramEpic,
  saveProfileFormRequestEpic,
  saveProfileFormSuccessEpic,
  saveProfileFormFailureEpic,
  deletePatientConditionEpic,
  deletePatientProgramEpic,
  deletePatientProgramItemEpic,
  savePatientProgramItemEpic,
  insertPatientProgramItemEpic,
  sendReminderEpic,
  sendPushNotificationEpic,
  loadPatientProgramEpic,
  loadPatientFailureEpic,
  loadPatientProgramActivityEpic,
  deleteSupportUserEpic
} from "./patients";
import {
  loadProgramsEpic,
  deleteProgramEpic,
  loadProgramEpic,
  saveProgramItemEpic,
  insertProgramItemEpic,
  saveProgramEpic,
  saveProgramFormRequestEpic,
  saveProgramFormSuccessEpic,
  saveProgramFormFailureEpic,
  deleteProgramItemEpic,
  saveProgramItemFormRequestEpic,
  saveProgramItemFormSuccessEpic,
  saveProgramItemFormFailureEpic,
  loadProgramFailureEpic,
  duplicateProgramEpic
} from "./programs";
import {
  loadAccountsEpic,
  deleteAccountEpic,
  loadAccountEpic,
  saveAccountEpic,
  loadActiveAccountEpic,
  saveAccountFormRequestEpic,
  saveAccountFormSuccessEpic,
  saveAccountFormFailureEpic,
  loadAccountFailureEpic
} from "./accounts";
import {
  loadTasksEpic,
  saveTaskEpic,
  deleteTaskEpic,
  saveTaskFormRequestEpic,
  saveTaskFormSuccessEpic,
  saveTaskFormFailureEpic,
  savePatientTaskFormRequestEpic,
  savePatientTaskFormSuccessEpic,
  savePatientTaskFormFailureEpic
} from "./tasks";
import {
  loadConditionsEpic,
  saveConditionEpic,
  deleteConditionEpic,
  saveConditionFormRequestEpic,
  saveConditionFormSuccessEpic,
  saveConditionFormFailureEpic
} from "./conditions";

import {
  loadAttachmentsEpic,
  uploadAttachmentsEpic,
  attachAttachmentsEpic,
  saveLibraryFormRequestEpic,
  saveLibraryFormSuccessEpic,
  importFormEpic,
  importFormSuccessEpic,
  getFileEpic
} from "./attachments";

import {
  loadUsersEpic,
  deleteUserEpic,
  loadUserEpic,
  saveUserEpic,
  saveUserFormRequestEpic,
  saveUserFormSuccessEpic,
  saveUserFormFailureEpic,
  sendReminderUserEpic,
  saveUserAcceptTermsEpic,
  userLookupEpic,
  deleteUserPermissionEpic,
  loadDashboardEpic,
  saveUserSuccessEpic,
  loadCliniciansEpic
} from "./users";

import {
  loadLocationsEpic,
  deleteLocationEpic,
  loadLocationEpic,
  saveLocationEpic,
  saveLocationFormRequestEpic,
  saveLocationFormSuccessEpic,
  saveLocationFormFailureEpic
} from "./locations";

export const rootEpic = combineEpics(
  loadHistoryEpic,

  handleErrorEpic,
  loginEpic,
  loginFormRequestEpic,
  loginFormSuccessEpic,
  loginFormFailureEpic,
  logoutEpic,
  forgotPasswordEpic,
  forgotPasswordFormRequestEpic,
  forgotPasswordFormSuccessEpic,
  forgotPasswordFormFailureEpic,
  resetPasswordEpic,
  resetPasswordFormRequestEpic,
  resetPasswordFormSuccessEpic,
  resetPasswordFormFailureEpic,

  loadPatientsEpic,

  loadTasksEpic,
  saveTaskEpic,
  deleteTaskEpic,
  saveTaskFormRequestEpic,
  saveTaskFormSuccessEpic,
  saveTaskFormFailureEpic,

  loadProgramEpic,
  loadProgramsEpic,
  saveProgramEpic,
  deleteProgramEpic,
  saveProgramItemEpic,
  insertProgramItemEpic,
  saveProgramFormRequestEpic,
  saveProgramFormSuccessEpic,
  saveProgramFormFailureEpic,
  deleteProgramItemEpic,
  saveProgramItemFormRequestEpic,
  saveProgramItemFormSuccessEpic,
  saveProgramItemFormFailureEpic,
  loadProgramFailureEpic,
  duplicateProgramEpic,

  loadAccountsEpic,
  deleteAccountEpic,
  loadAccountEpic,
  loadActiveAccountEpic,
  saveAccountEpic,
  saveAccountFormRequestEpic,
  saveAccountFormSuccessEpic,
  saveAccountFormFailureEpic,
  loadAccountFailureEpic,

  loadPatientEpic,
  savePatientEpic,
  deletePatientEpic,
  savePatientSuccessEpic,
  savePatientConditionEpic,
  linkProgramEpic,
  savePatientProgramEpic,
  saveProfileFormRequestEpic,
  saveProfileFormSuccessEpic,
  saveProfileFormFailureEpic,
  deletePatientConditionEpic,
  deletePatientProgramEpic,
  deletePatientProgramItemEpic,
  savePatientProgramItemEpic,
  insertPatientProgramItemEpic,
  loadPatientProgramEpic,
  sendReminderEpic,
  sendPushNotificationEpic,

  loadPatientFailureEpic,
  loadPatientProgramActivityEpic,
  deleteSupportUserEpic,
  savePatientTaskFormRequestEpic,
  savePatientTaskFormSuccessEpic,
  savePatientTaskFormFailureEpic,

  loadConditionsEpic,
  saveConditionEpic,
  deleteConditionEpic,
  saveConditionFormRequestEpic,
  saveConditionFormSuccessEpic,
  saveConditionFormFailureEpic,

  loadAttachmentsEpic,
  uploadAttachmentsEpic,
  attachAttachmentsEpic,
  saveLibraryFormRequestEpic,
  saveLibraryFormSuccessEpic,
  importFormEpic,
  importFormSuccessEpic,
  getFileEpic,

  loadLocationsEpic,
  deleteLocationEpic,
  loadLocationEpic,
  saveLocationEpic,
  saveLocationFormRequestEpic,
  saveLocationFormSuccessEpic,
  saveLocationFormFailureEpic,

  loadUsersEpic,
  deleteUserEpic,
  loadUserEpic,
  saveUserEpic,
  saveUserSuccessEpic,
  saveUserFormRequestEpic,
  saveUserFormSuccessEpic,
  saveUserFormFailureEpic,
  sendReminderUserEpic,
  saveUserAcceptTermsEpic,
  userLookupEpic,
  deleteUserPermissionEpic,
  loadDashboardEpic,
  loadCliniciansEpic
);



// WEBPACK FOOTER //
// ./src/epics/index.js